export default "__VITE_ASSET__B87s5dGX__"